module.exports = __webpack_public_path__ + "static/media/Home-warranty-hippo-green.6590b530.gif";